import { ClientOnly, type RouteMetadata } from '@go-beyond/react'
import { OrigensLogo } from '@origens/ui'
import type { InferPageProps } from '@go-beyond/schema'
import { ThemeToggleClient } from '../components/theme-toggle-client.js'
import './site.css'
import { page } from './page.schema.js'

type Props = InferPageProps<typeof page>

export const metadata: RouteMetadata = {
  title: 'Origens',
  description: 'Take back your web. Coming soon.',
  canonical: '/',
  lang: 'en',
  robots: 'noindex, nofollow',
}

export default function HomePage({ signInURL }: Props) {
  return (
    <div className="landing">
      <ClientOnly fallback={null}>
        <ThemeToggleClient />
      </ClientOnly>
      <main className="landing__main">
        <OrigensLogo className="landing__logo" />
        <p className="landing__brand">Origens</p>
        <h1 className="landing__headline">Take back your web. Coming soon.</h1>
        <div className="landing__actions">
          <a className="landing__cta landing__cta--primary" href={signInURL}>
            Log in
          </a>
        </div>
      </main>
      <footer className="landing__footer">
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </footer>
    </div>
  )
}
